<script lang="jsx">
const filter = (suggestions, value) => {
  const escapedValue = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return suggestions.filter((suggestion) => suggestion.name.match(new RegExp(escapedValue, 'ig')))
}
export default {
  props: {
    context: {},
    label: {},
    id: {},
    suggestions: {},
    update: {},
    itemSelected: {},
    value: {},
    clearOnSelection: {},
    renderSuggestion: {},
    makeKey: {},
    selectFromInput: {},
    tagName: {},
    allowNewInputs: {
      default: true,
    },
  },

  data: () => ({
    selectedIndex: 0,
    previousValue: '',
    showSuggestions: false,
  }),

  updated() {
    // if (this.selectedIndex === 0) document.querySelector(`#${this.id}`).focus();
  },

  methods: {
    changeSelection(e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Enter') e.preventDefault()
      else this.selectedIndex = 0

      this.showSuggestions = true

      if (e.key === 'ArrowDown') {
        if (this.selectedIndex === 0) this.previousValue = this.value

        this.selectedIndex = (this.selectedIndex + 1) % (filter(this.suggestions, this.value).length + 1)

        // if (this.selectedIndex === 0) {
        //   this.update(this.previousValue);
        // } else {
        //   this.update(
        //     filter(this.suggestions, this.value)[this.selectedIndex - 1]
        //   );
        // }
      }

      if (e.key === 'ArrowUp') {
        if (this.selectedIndex === 0) {
          this.previousValue = this.value
          this.selectedIndex = filter(this.suggestions, this.value).length
        } else {
          this.selectedIndex = (this.selectedIndex - 1) % (filter(this.suggestions, this.value).length + 1)
        }
      }

      if (e.key === 'Enter') {
        if (this.selectedIndex !== 0) {
          this.itemSelected(filter(this.suggestions, this.value)[this.selectedIndex - 1])
          if (this.clearOnSelection) this.update('')
          this.showSuggestions = false
          this.selectedIndex = 0
        } else {
          if (this.allowNewInputs) this.selectNewTag() //here
        }
      }

      if (e.key === 'Escape') this.showSuggestions = false

      const completions = [].slice.call(document.querySelectorAll(`#ac-${this.id} [data-item-index]`))

      completions.forEach((completion) => completion.setAttribute(`data-item-selected`, 'false'))

      if (this.selectedIndex > 0) {
        const selectedItem = document.querySelector(`#ac-${this.id} [data-item-index='${this.selectedIndex}']`)

        if (selectedItem) {
          selectedItem.setAttribute(`data-item-selected`, 'true')

          if (this.selectedIndex > 3) {
            selectedItem.scrollIntoView()
          } else {
            const first = document.querySelector(`#ac-${this.id} [data-item-index='1']`)

            if (first) first.scrollIntoView()
          }
        }
      }
    },

    canAddTag() {
      return (
        this.value &&
        this.selectFromInput &&
        this.suggestions.some((item) => {
          return item.name === this.value
        }) === false
      )
    },

    selectNewTag() {
      const suggestion = {
        id: this.value,
        name: this.value,
      }

      this.itemSelected(suggestion)
      if (this.clearOnSelection) this.update('')
    },

    getLength() {
      let length = 0

      if (this.canAddTag()) {
        length = filter(this.suggestions, this.value).length + 1
      } else {
        length = (this.value == null ? this.suggestions : filter(this.suggestions, this.value)).length
      }

      return length
    },
  },

  render() {
    return (
      <div id={`ac-${this.id}`} class="autocomplete-input">
        <label for={this.id}>{this.label}</label>
        <input
          type="text"
          autocomplete="off"
          oninput={(e) => {
            this.update(e.target.value)
          }}
          onkeydown={(e) => this.changeSelection(e)}
          onfocus={() => {
            // e.target.scrollIntoView(),
            this.showSuggestions = true
          }}
          onblur={() => {
            // since onblur fires before the onclick event we need to wait a
            // bit before hiding the suggestions
            setTimeout(() => (this.showSuggestions = false), 250)
          }}
          id={this.id}
          value={this.value}
        />
        <div>
          <ul class={this.showSuggestions ? 'show' : 'hide'} data-length={this.getLength()}>
            {this.canAddTag() ? (
              <li onclick={() => this.selectNewTag()}>
                <span>
                  Add "{this.value}" as new {this.tagName ? this.tagName : 'tag'}
                </span>
              </li>
            ) : (
              ''
            )}

            {(this.value == null ? this.suggestions : filter(this.suggestions, this.value)).map((suggestion, i) => (
              <li
                key={this.makeKey ? this.makeKey(suggestion) : suggestion.id == null ? suggestion.name : suggestion.id}
                data-item-index={i + 1}
                onclick={() => this.itemSelected(suggestion)}
              >
                {(this.renderSuggestion || (() => <span>{suggestion.name}</span>))(suggestion)}
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  },
}
</script>
